'use client';

import { useTranslations } from 'next-intl';
import { ShieldCheck } from 'lucide-react';
import { cn } from '@/shared/utils/cn';

interface PhotoConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** compact = tiny inline variant (chips/rows); default = full boxed statement. */
  compact?: boolean;
  className?: string;
}

/**
 * The ONE guardian-consent checkbox (GDPR Art. 9) shown at every photo-upload
 * entry point — single control, single wording (`stories.characters.photoConsent`).
 * Gate the uploader/generate on `checked`; submit `PHOTO_CONSENT_VERSION` when set.
 */
export function PhotoConsentCheckbox({ checked, onChange, compact, className }: PhotoConsentCheckboxProps) {
  const t = useTranslations('stories.characters.photoConsent');
  return (
    <label
      className={cn(
        'flex cursor-pointer items-start gap-2 rounded-md bg-muted/40 p-2 text-muted-foreground',
        compact ? 'text-[10px]' : 'text-xs',
        className,
      )}
    >
      <input
        type="checkbox"
        className={cn('mt-0.5 shrink-0 accent-primary', compact ? 'size-3' : 'size-4')}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid="photo-consent-checkbox"
      />
      <span className="flex items-start gap-1.5">
        {!compact && <ShieldCheck className="mt-0.5 size-4 shrink-0 text-primary" />}
        <span>{t('label')}</span>
      </span>
    </label>
  );
}
